module.exports = __webpack_public_path__ + "img/dual-ring-loader-transparent.1020fd8e.gif";